const values = [
  {name: 'España (+34)', value: 1, priority: true},
  {name: 'Francia (+33)', value: 67, priority: false},
  {name: 'Marruecos (+212)', value: 137, priority: false},
  {name: 'Bélgica (+32)', value: 26, priority: false},
  {name: 'Afghanistan (+93)', value: 2, priority: false},
  {name: 'Albania (+355)', value: 3, priority: false},
  {name: 'Alemania (+49)', value: 4, priority: false},
  {name: 'Andorra (+376)', value: 12, priority: false},
  {name: 'Angola (+244)', value: 6, priority: false},
  {name: 'Anguila (+1264)', value: 7, priority: false},
  {name: 'Antigua y Barbuda (+1268)', value: 8, priority: false},
  {name: 'Antillas Holandesas (+599)', value: 5, priority: false},
  {name: 'Arabia Saudi (+966)', value: 9, priority: false},
  {name: 'Argelia (+213)', value: 10, priority: true},
  {name: 'Argentina (+54)', value: 13, priority: false},
  {name: 'Armenia (+374)', value: 11, priority: false},
  {name: 'Aruba (+297)', value: 14, priority: false},
  {name: 'Australia (+61)', value: 15, priority: false},
  {name: 'Austria (+43)', value: 16, priority: false},
  {name: 'Azerbayán (+994)', value: 17, priority: false},
  {name: 'Bahamas (+1242)', value: 18, priority: false},
  {name: 'Bahrein (+973)', value: 19, priority: false},
  {name: 'Bangladesh (+880)', value: 20, priority: false},
  {name: 'Barbados (+1246)', value: 21, priority: false},
  {name: 'Belice (+501)', value: 22, priority: false},
  {name: 'Benin (+229)', value: 23, priority: false},
  {name: 'Bermuda (+1441)', value: 24, priority: false},
  {name: 'Bielorrusia (+375)', value: 25, priority: false},
  {name: 'Bolivia (+591)', value: 27, priority: false},
  {name: 'Bosnia (+387)', value: 28, priority: false},
  {name: 'Botswana (+267)', value: 29, priority: false},
  {name: 'Brasil (+55)', value: 30, priority: false},
  {name: 'Brunei (+673)', value: 31, priority: false},
  {name: 'Bulgaria (+359)', value: 32, priority: false},
  {name: 'Burkina Faso (+226)', value: 33, priority: false},
  {name: 'Burundi (+257)', value: 34, priority: false},
  {name: 'Buthan (+975)', value: 35, priority: false},
  {name: 'Cabo Verde (+238)', value: 36, priority: false},
  {name: 'Camboya (+855)', value: 37, priority: false},
  {name: 'Camerun (+237)', value: 38, priority: false},
  {name: 'Canadá (+1)', value: 39, priority: false},
  {name: 'Chad (+235)', value: 40, priority: false},
  {name: 'Chile (+56)', value: 41, priority: false},
  {name: 'China (+86)', value: 42, priority: false},
  {name: 'Chipre (+357)', value: 43, priority: false},
  {name: 'Colombia (+57)', value: 44, priority: false},
  {name: 'Comoras (+269)', value: 45, priority: false},
  {name: 'Corea del Sur (+82)', value: 46, priority: false},
  {name: 'Costa de Marfil (+255)', value: 47, priority: false},
  {name: 'Costa Rica (+506)', value: 48, priority: false},
  {name: 'Croacia (+385)', value: 49, priority: false},
  {name: 'Cuba (+53)', value: 50, priority: false},
  {name: 'Dinamarca (+45)', value: 51, priority: false},
  {name: 'Djibuti (+253)', value: 52, priority: false},
  {name: 'Dominica (+1767)', value: 53, priority: false},
  {name: 'Ecuador (+593)', value: 54, priority: false},
  {name: 'Egipto (+202)', value: 55, priority: false},
  {name: 'El Salvador (+503)', value: 56, priority: false},
  {name: 'Emiratos Árabes Unidos (+971)', value: 57, priority: false},
  {name: 'Eritrea (+291)', value: 58, priority: false},
  {name: 'Eslovaquia (+421)', value: 59, priority: false},
  {name: 'Eslovenia (+386)', value: 60, priority: false},
  {name: 'Estados Unidos (+1)', value: 61, priority: false},
  {name: 'Estonia (+372)', value: 62, priority: false},
  {name: 'Etiopia (+251)', value: 63, priority: false},
  {name: 'Fidji (+679)', value: 64, priority: false},
  {name: 'Filipinas (+63)', value: 65, priority: false},
  {name: 'Finlandia (+358)', value: 66, priority: false},
  {name: 'Gabón (+241)', value: 68, priority: false},
  {name: 'Gambia (+220)', value: 69, priority: false},
  {name: 'Georgia (+995)', value: 70, priority: false},
  {name: 'Ghana (+233)', value: 71, priority: false},
  {name: 'Gibraltar (+350)', value: 72, priority: false},
  {name: 'Granada (+1473)', value: 73, priority: false},
  {name: 'Grecia (+30)', value: 74, priority: false},
  {name: 'Guadalupe (Caribe Francés) (+590)', value: 76, priority: false},
  {name: 'Guam (USA) (+1671)', value: 75, priority: false},
  {name: 'Guatemala (+502)', value: 77, priority: false},
  {name: 'Guernsey (+44)', value: 112, priority: false},
  {name: 'Guinea (+224)', value: 79, priority: false},
  {name: 'Guinea Ecuatorial (+240)', value: 80, priority: false},
  {name: 'Guinea-Bissau (+245)', value: 81, priority: false},
  {name: 'Guyana (+592)', value: 82, priority: false},
  {name: 'Guyana Francesa (Caribe Francés) (+590)', value: 83, priority: false},
  {name: 'Haiti (+1509)', value: 84, priority: false},
  {name: 'Holanda (+31)', value: 85, priority: false},
  {name: 'Honduras (+504)', value: 86, priority: false},
  {name: 'Hong Kong (China) (+852)', value: 87, priority: false},
  {name: 'Hungría (+36)', value: 88, priority: false},
  {name: 'India (+91)', value: 89, priority: false},
  {name: 'Indonesia (+62)', value: 90, priority: false},
  {name: 'Irak (+964)', value: 91, priority: false},
  {name: 'Iran (+98)', value: 92, priority: false},
  {name: 'Irlanda (+353)', value: 93, priority: false},
  {name: 'Isla de Man (+500)', value: 97, priority: false},
  {name: 'Isla Mayotte (Mayotte Island) (+269)', value: 99, priority: false},
  {name: 'Islandia (+354)', value: 105, priority: false},
  {name: 'Islas Caimán (+1345)', value: 94, priority: false},
  {name: 'Islas Cook (+682)', value: 95, priority: false},
  {name: 'Islas Faroe (+298)', value: 106, priority: false},
  {name: 'Islas Malvinas (+500)', value: 96, priority: false},
  {name: 'Islas Marianas del Norte (+1670)', value: 98, priority: false},
  {name: 'Islas Norfolk (+672)', value: 100, priority: false},
  {name: 'Islas Reunión (+672)', value: 101, priority: false},
  {name: 'Islas San Pedro y Miquelón (+508)', value: 102, priority: false},
  {name: 'Islas Solomon (+677)', value: 103, priority: false},
  {name: 'Islas Vírgenes Británicas (+1284)', value: 104, priority: false},
  {name: 'Israel (+972)', value: 107, priority: false},
  {name: 'Italia (+39)', value: 108, priority: false},
  {name: 'Jamaica (+1876)', value: 110, priority: false},
  {name: 'Japón (+81)', value: 111, priority: false},
  {name: 'Jersey (+44)', value: 169, priority: false},
  {name: 'Jordania (+962)', value: 109, priority: false},
  {name: 'Kazakhstan (+7)', value: 113, priority: false},
  {name: 'Kenya (+254)', value: 115, priority: false},
  {name: 'Kiribati (+686)', value: 116, priority: false},
  {name: 'Kosovo (+385)', value: 117, priority: false},
  {name: 'Kuwait (+965)', value: 118, priority: false},
  {name: 'Kyrgyzstan (+996)', value: 114, priority: false},
  {name: 'La Reunión (+262)', value: 120, priority: false},
  {name: 'Laos (+856)', value: 119, priority: false},
  {name: 'Lesotho (+266)', value: 121, priority: false},
  {name: 'Letonia (+371)', value: 122, priority: false},
  {name: 'Líbano (+961)', value: 123, priority: false},
  {name: 'Liberia (+231)', value: 124, priority: false},
  {name: 'Libia (+218)', value: 125, priority: false},
  {name: 'Liechtenstein (+423)', value: 126, priority: false},
  {name: 'Lituania (+310)', value: 127, priority: false},
  {name: 'Luxemburgo (+352)', value: 128, priority: false},
  {name: 'Macao (+853)', value: 129, priority: false},
  {name: 'Macedonia (+389)', value: 130, priority: false},
  {name: 'Madagascar (+261)', value: 131, priority: false},
  {name: 'Malasia (+60)', value: 134, priority: false},
  {name: 'Malawi (+265)', value: 132, priority: false},
  {name: 'Maldivas (+960)', value: 135, priority: false},
  {name: 'Mali (+223)', value: 136, priority: false},
  {name: 'Malta (+356)', value: 133, priority: false},
  {name: 'Martinica (Caribe Francés) (+590)', value: 138, priority: false},
  {name: 'Mauricio (+230)', value: 139, priority: false},
  {name: 'Mauritania (+222)', value: 140, priority: false},
  {name: 'México (+52)', value: 141, priority: false},
  {name: 'Micronesia (+691)', value: 142, priority: false},
  {name: 'Moldavia (+373)', value: 143, priority: false},
  {name: 'Monaco (+377)', value: 144, priority: false},
  {name: 'Mongolia (+976)', value: 145, priority: false},
  {name: 'Montenegro (+382)', value: 189, priority: false},
  {name: 'Montserrat (+1664)', value: 146, priority: false},
  {name: 'Mozambique (+258)', value: 147, priority: false},
  {name: 'Myanmar (+95)', value: 148, priority: false},
  {name: 'Namibia (+264)', value: 149, priority: false},
  {name: 'Nepal (+977)', value: 150, priority: false},
  {name: 'Nicaragua (+505)', value: 151, priority: false},
  {name: 'Niger (+227)', value: 152, priority: false},
  {name: 'Nigeria (+234)', value: 153, priority: false},
  {name: 'Noruega (+47)', value: 154, priority: false},
  {name: 'Nueva Caledonia (+687)', value: 155, priority: false},
  {name: 'Nueva Zelanda (+64)', value: 156, priority: false},
  {name: 'Oman (+968)', value: 157, priority: false},
  {name: 'Pakistán (+92)', value: 158, priority: false},
  {name: 'Palestina (+972)', value: 159, priority: false},
  {name: 'Panamá (+507)', value: 160, priority: false},
  {name: 'Papua Nueva Guinea (+675)', value: 161, priority: false},
  {name: 'Paraguay (+595)', value: 162, priority: false},
  {name: 'Peru (+51)', value: 163, priority: false},
  {name: 'Polinesia Francesa (Tahiti) (+689)', value: 164, priority: false},
  {name: 'Polonia (+48)', value: 165, priority: false},
  {name: 'Portugal (+351)', value: 166, priority: false},
  {name: 'Puerto Rico (+1787)', value: 167, priority: false},
  {name: 'Qatar (+974)', value: 168, priority: false},
  {name: 'Reino Unido (+44)', value: 78, priority: false},
  {name: 'República Centroafricana (+236)', value: 173, priority: false},
  {name: 'República Checa (+420)', value: 174, priority: false},
  {name: 'República de Palau (+680)', value: 176, priority: false},
  {name: 'República de Yemen (+967)', value: 177, priority: false},
  {name: 'República Democrática del Congo (+243)', value: 175, priority: false},
  {name: 'República Dominicana (+1809)', value: 170, priority: false},
  {name: 'República Dominicana (+1829)', value: 171, priority: false},
  {name: 'República Dominicana (+1849)', value: 172, priority: false},
  {name: 'Ruanda (+250)', value: 178, priority: false},
  {name: 'Rumanía (+40)', value: 179, priority: false},
  {name: 'Rusia (+7)', value: 180, priority: false},
  {name: 'Samoa (+685)', value: 181, priority: false},
  {name: 'San Kitts y Nevis (+1869)', value: 182, priority: false},
  {name: 'San Marino (+378)', value: 184, priority: false},
  {name: 'San Vicente y las Granadinas (+1784)', value: 185, priority: false},
  {name: 'Santa Lucía (+1758)', value: 183, priority: false},
  {name: 'Santo Tomé y Príncipe (+239)', value: 186, priority: false},
  {name: 'Senegal (+221)', value: 187, priority: false},
  {name: 'Serbia (+381)', value: 188, priority: false},
  {name: 'Seychelles (+248)', value: 190, priority: false},
  {name: 'Sierra Leona (+232)', value: 191, priority: false},
  {name: 'Singapur (+65)', value: 192, priority: false},
  {name: 'Siria (+963)', value: 193, priority: false},
  {name: 'Somalia (+252)', value: 195, priority: false},
  {name: 'Sri Lanka (+94)', value: 194, priority: false},
  {name: 'Sudáfrica (+27)', value: 196, priority: false},
  {name: 'Sudán (+249)', value: 197, priority: false},
  {name: 'Suecia (+46)', value: 198, priority: false},
  {name: 'Suiza (+41)', value: 199, priority: false},
  {name: 'Surinam (+597)', value: 200, priority: false},
  {name: 'Swazilandia (+268)', value: 201, priority: false},
  {name: 'Tailandia (+66)', value: 202, priority: false},
  {name: 'Taiwan (+886)', value: 203, priority: false},
  {name: 'Tanzania (+255)', value: 204, priority: false},
  {name: 'Tayikistan (+7)', value: 205, priority: false},
  {name: 'Timor (+670)', value: 206, priority: false},
  {name: 'Togo (+228)', value: 207, priority: false},
  {name: 'Tonga (+676)', value: 208, priority: false},
  {name: 'Trinidad y Tobago (+1868)', value: 209, priority: false},
  {name: 'Túnez (+216)', value: 210, priority: false},
  {name: 'Turkmenistan (+993)', value: 213, priority: false},
  {name: 'Turks and Caicos (+1649)', value: 212, priority: false},
  {name: 'Turquía (+90)', value: 211, priority: false},
  {name: 'Ucrania (+380)', value: 214, priority: false},
  {name: 'Uganda (+256)', value: 215, priority: false},
  {name: 'Uruguay (+598)', value: 216, priority: false},
  {name: 'Uzbekistán (+998)', value: 217, priority: false},
  {name: 'Vanuatu (+678)', value: 218, priority: false},
  {name: 'Venezuela (+58)', value: 219, priority: false},
  {name: 'Vietnam (+84)', value: 220, priority: false},
  {name: 'Zambia (+260)', value: 222, priority: false},
  {name: 'Zimbawe (+263)', value: 221, priority: false}
]

const sort = () =>(
  values.sort((a, b) => {
    return a.name.localeCompare(b.name)
  })
)

const filter = (priority) => (
  sort().filter((value) => {
    return (value.priority === priority)
  })
)

const getValues = () => {
  const d = [{name: 'Divider', value: undefined}]
  const a = filter(true)
  const b = filter(false)

  return [...a, ...d, ...b]
}

export default getValues()



// WEBPACK FOOTER //
// ./src/shared/routers/languages/es/arrays/prefixes.js